module.exports = __webpack_public_path__ + "static/iphone-secondapp-88072769c1c51b605a4df80a3e2d8fa1.svg";